import { Box } from '@mui/system';
import React from 'react'
import TablePagination from '@mui/material/TablePagination';
import { Pagination } from '@interfaces/pagination';

export const CustomPagination = ({ change, pagination }: { change: Function, pagination: Pagination }) => {
    const onPageChange = (event: unknown, value: number) => {
        change({ page: value + 1, limit: pagination.limit })
    };
    const onRowChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        change({ page: 1, limit: +event.target.value })
    };

    // console.log(pagination)
    return (
        <Box p={3} display="flex" justifyContent="center">
            <TablePagination
                showFirstButton
                showLastButton
                colSpan={3}
                rowsPerPageOptions={[6, 12, 24]}
                component="div"
                count={pagination.total as number}
                rowsPerPage={pagination.limit as number}
                page={pagination.page ? pagination.page - 1 : 1}
                onPageChange={onPageChange}
                onRowsPerPageChange={onRowChange}
            />
        </Box>
    )
}
